import React from 'react';
import { Link } from 'react-router-dom';
import styles from './AppCard.module.css';

function AppCard({
  icon,
  iconIsImage,
  name,
  status,
  statusClass,
  tagline,
  subtitle,
  features,
  links,
  slug
}) {
  const handleDisabledClick = (e) => {
    e.preventDefault();
  };

  const getLinkClassName = (link) => {
    const classes = [styles.link];
    if (link.disabled) classes.push(styles.disabled);
    if (link.loading) classes.push(styles.loading);
    if (link.active) classes.push(styles.active);
    return classes.join(' ');
  };

  return (
    <div className={styles.appCard}>
      <div className={styles.appHeader}>
        <div className={styles.appIcon}>
          {iconIsImage ? (
            <img src={icon} alt={`${name} icon`} className={styles.appIconImg} />
          ) : (
            icon
          )}
        </div>
        <div className={styles.appTitle}>
          <h3>{name}</h3>
          <span className={`${styles.status} ${statusClass ? styles[statusClass] : ''}`}>
            {status}
          </span>
        </div>
      </div>

      <p className={styles.tagline}>{tagline}</p>
      <h4 className={styles.subtitle}>{subtitle}</h4>

      <ul className={styles.features}>
        {features.map((feature, index) => (
          <li key={index}>{feature}</li>
        ))}
      </ul>

      <div className={styles.links}>
        {links.map((link, index) => (
          <a
            key={index}
            href={link.url}
            className={getLinkClassName(link)}
            onClick={link.disabled ? handleDisabledClick : undefined}
            aria-disabled={link.disabled}
            target={link.external ? "_blank" : undefined}
            rel={link.external ? "noopener noreferrer" : undefined}
          >
            {link.loading ? 'Loading...' : link.text}
          </a>
        ))}
      </div>

      {slug && (
        <Link to={`/apps/${slug}`} className={styles.learnMore}>
          Learn more about {name}
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M5 12h14M12 5l7 7-7 7"/>
          </svg>
        </Link>
      )}
    </div>
  );
}

export default AppCard;
